import { CONSTANTS } from '../constants/Constants';

const { ACTIONS } = CONSTANTS;

const initialState = {
  notAuthenticated: true,
  loading: true,
};

export default (prevState, action) => {
  const state = prevState || initialState;
  switch (action.type) {
    case ACTIONS.FETCH_AUTHENTICATION:
      return {
        ...state,
        notAuthenticated: action.payload,
      };
    case ACTIONS.APPLICATIONS_AUTH_LOADER:
      return {
        ...state,
        loading: action.payload,
      };
    default: return state;
  }
};
